import { Navigate, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Card, Space, Typography } from "antd";

import { getPayslipById } from "../api/payslipAPI";
import { PayslipForm } from "../components/PayslipForm";

const { Title } = Typography;

const UpdatePayslip = () => {
  const { id } = useParams();
  const payslipId = id;

  const { data: payslipData, isLoading } = useQuery({
    queryKey: ["payslip", payslipId],
    queryFn: () => getPayslipById(payslipId),
    enabled: !!payslipId,
  });

  if (!payslipId) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Update Payslip
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          Payslip Information
        </Title>

        {!isLoading && (
          <PayslipForm
            initialData={{
              ...payslipData,
              userId: payslipData?.user?.id || payslipData?.userId,
              branchId: payslipData?.branch?.id || payslipData?.branchId,
              isUnder60: payslipData.isUnder60,
            }}
            mode="update"
            payslipId={payslipId}
          />
        )}
      </Card>
    </Space>
  );
};

export default UpdatePayslip;
